/** Keep the complete desktop flower over scenery, including room for its fade. */
export function desktopHomeArtwork(width: number, flowerScale: number) {
  const contentBottom = 48 + 58 * flowerScale + 24 + 416 * flowerScale;
  const height = Math.max(Math.min(width, 1920) * 558 / 1672, contentBottom + 72);
  const imageWidth = Math.max(width, height * 1672 / 558);
  return { height, imageWidth, imageHeight: imageWidth * 558 / 1672 };
}
